const sizePrefixes = ["", "K", "M", "B"];

export const stripTrailingZeros = (s) =>
  s.replace(/(\.[1-9]*)(0+)$/, "$1").replace(/\.$/, "");

export function toHumanReadableSize(n) {
  if (n < 10000) {
    return formatNumber(n);
  }
  // log base 1000 of x = (ln x / ln 1000)
  const log1000 = n === 0 ? 0 : Math.floor(Math.log(n) / Math.log(1000));
  const val = (n / Math.pow(1000, log1000)).toFixed(1);
  return `${stripTrailingZeros(val)}${sizePrefixes[log1000]}`;
}

export function formatNumber(n) {
  return n.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
}
